export default __webpack_public_path__ + "static/media/broze-star.e6f5eb96.svg";